import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FundraiserSliderComponent } from './components/fundraiser-slider/fundraiser-slider.component';
import { NgxGlideModule } from 'ngx-glide';

@NgModule({
  declarations: [FundraiserSliderComponent],
  imports: [
    CommonModule,
    NgxGlideModule
  ],
  exports: [FundraiserSliderComponent]
})
export class FundraiserSliderModule { }
